import {autoserialize, autoserializeAs, inheritSerialization} from 'cerialize';
import * as moment from 'moment';
import {MomentTransformer} from '../helpers/moment-transformer';
import {OnDeserialized} from '../helpers/on-deserialized';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class ProgrammaOnderdeel extends ModelBase {
  public static readonly type = 'ProgrammaOnderdeel';
  public readonly type = ProgrammaOnderdeel.type;

  @autoserialize
  public id: number;

  @autoserialize
  public event_id: number;

  @autoserialize
  public naam: string;

  @autoserialize
  public beschrijving: string;

  @autoserialize
  public adres: string;

  @autoserializeAs(MomentTransformer, 'begintijd')
  public begintijd: moment.Moment;

  @autoserializeAs(MomentTransformer, 'eindtijd')
  public eindtijd: moment.Moment;

  @autoserializeAs('group_ids')
  public groupIds: number[];

  public timeString: string;

  // noinspection JSUnusedGlobalSymbols
  public static OnDeserialized: OnDeserialized<ProgrammaOnderdeel> = (instance) => {
    if (instance.begintijd.dayOfYear() === instance.eindtijd.dayOfYear() && instance.begintijd.year() === instance.eindtijd.year()) {
      instance.timeString = instance.begintijd.format('D MMM, HH:mm') + ' - ' + instance.eindtijd.format('HH:mm');
    } else {
      instance.timeString = instance.begintijd.format('D MMM, HH:mm') + ' - ' + instance.eindtijd.format('D MMM, HH:mm');
    }
  }
}
